import { Pipe, PipeTransform } from '@angular/core';

import { GetEnumValuesDto } from '../api/models';

@Pipe({
  name: 'enumToText',
  standalone: true,
})
export class EnumToTextConvertorPipe implements PipeTransform {
  transform(enumKey: number, enumValues?: GetEnumValuesDto[]): any {
    if (enumKey == null || !enumValues) return '-';

    const value = enumValues.find((item) => item.key == enumKey)?.value;

    if (value) return value;
    else return '-';
  }
}
